<template>
  <div class="page-triplea-home">
      <HomeSearchComponent />
      <HomeCategorySection />
      <CatalogSection :sectionTitle="'Veja esses 6 destaques que selecionamos para voce'" />
      <CatalogSection :sectionTitle="'Lançamentos Triple A'" />
      <ProspectingSection />
      <ExploreSection />
      <BestProperties />
      <BannerSection bg="#efebe7" />
      <AdvertiseModal />
      <TripleaContactModal />
  </div>
</template>
<script>

import "@/assets/scss/custom/triplea/_home.scss"

import Vue from "vue";
import HomeSearchComponent from '../components/apolar/triplea/home/home-search.vue'
import HomeCategorySection from '../components/apolar/triplea/home/home-category-section.vue'
import CatalogSection from '../components/apolar/triplea/catalog-section.vue'
import ProspectingSection from '../components/apolar/triplea/home/prospecting-section.vue'
import ExploreSection from '../components/apolar/triplea/home/explore-section.vue'
import BestProperties from '../components/apolar/triplea/home/best-properties.vue'
import BannerSection from '../components/apolar/triplea/home/banner-section.vue'
import AdvertiseModal from '../components/apolar/triplea/modals/advertise-modal.vue'
import TripleaContactModal from '../components/apolar/triplea/modals/contact-modal.vue'

export default {
  name: "triplea",
  components: {
    HomeSearchComponent,
    HomeCategorySection,
    CatalogSection,
    ProspectingSection,
    ExploreSection,
    BestProperties,
    BannerSection,
    AdvertiseModal,
    TripleaContactModal,
  },
  metaInfo() {
    return {
      title: "Triple A",
      meta: [
        {
          vmid: "description",
          name: "description",
          content:"Apolar Triple A"
        }
      ]
    };
  },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
  }
};
</script>
